"use strict";

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es6.array.for-each.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

require("core-js/modules/es6.object.define-properties.js");

require("core-js/modules/es6.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lngPathCorrector = void 0;

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.regexp.search.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.object.keys.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _url = require("url");

var _index = require("./index");

var _queryString = require("query-string");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var parseAs = function parseAs(originalAs, href) {
  var asType = (0, _typeof2["default"])(originalAs);
  var as;

  if (asType === 'undefined') {
    as = (0, _url.format)(href, {
      unicode: true
    });
  } else if (asType === 'string') {
    as = originalAs;
  } else {
    throw new Error("'as' type must be 'string', but it is ".concat(asType));
  }

  return as;
};

var parseHref = function parseHref(originalHref) {
  var hrefType = (0, _typeof2["default"])(originalHref);
  var href;

  if (hrefType === 'string') {
    href = (0, _url.parse)(originalHref, true
    /* parseQueryString */
    );
  } else if (hrefType === 'object') {
    href = _objectSpread({}, originalHref);
    href.query = originalHref.query ? _objectSpread({}, originalHref.query) : {};
  } else {
    throw new Error("'href' type must be either 'string' or 'object', but it is ".concat(hrefType));
  }

  return href;
};

var getHref = function getHref(pathname, href, queryLength) {
  if (typeof href.href === 'string') {
    var pathList = href.href.split('/');
    var asList = pathname.split('/');
    var regex = /\[(.*?)\]/gm;
    var obj = {};

    for (var i = 0; i < pathList.length; i++) {
      var match = regex.exec(pathList[i]);

      if (match !== null) {
        var key = match[1];
        var val = asList[i];
        obj[key] = val;
        href.query[key] = val;
        regex.lastIndex = 0;
      }
    }

    var str = queryLength > 0 ? '&' : '?';
    return "".concat(href.href).concat(str).concat((0, _queryString.stringify)(obj));
  } else {
    return href;
  }
};

var lngPathCorrector = function lngPathCorrector(config, currentRoute, currentLanguage) {
  var allLanguages = config.allLanguages,
      localeSubpaths = config.localeSubpaths;
  var originalAs = currentRoute.as,
      originalHref = currentRoute.href;
  var href = parseHref(originalHref);
  var as = parseAs(originalAs, href); // return { as, href }

  /*
    url.format prefers the 'url.search' string over
    the 'url.query' object, so remove the search
    string to ensure the query object is used.
  */

  delete href.search;
  /*
    Strip any/all subpaths from the `as` value
  */
  // Object.values(localeSubpaths).forEach((subpath: string) => {
  // if (subpathIsPresent(as, subpath)) {
  //     as = removeSubpath(as, subpath)
  //   }
  // })

  if ((0, _index.subpathIsRequired)(config, currentLanguage)) {
    var basePath = "".concat(href.protocol, "//").concat(href.host);
    var currentAs = as.replace(basePath, '');
    var parsedAs = (0, _url.parse)(currentAs);
    var subpath = (0, _index.subpathFromLng)(config, currentLanguage);
    var pathname = typeof parsedAs.pathname === "string" && parsedAs.pathname.length > 0 ? parsedAs.pathname.replace(/\/$/, '') : '/';
    var search = typeof parsedAs.search === "string" ? parsedAs.search : '';
    var hash = typeof parsedAs.hash === "string" ? parsedAs.hash : '';
    as = "".concat(pathname, "/").concat(subpath).concat(search).concat(hash); // @TODO I have to change pathname due to the unfixed error https://github.com/isaachinman/next-i18next/issues/413

    var query = href.query;
    var queryLength = Object.keys(query).length;

    if (originalAs) {
      var newHref = getHref(pathname, href, queryLength);
      href.href = newHref;
    }

    href.query.lng = currentLanguage;
    href.query.subpath = subpath;
  }

  return {
    as: as,
    href: href
  };
};

exports.lngPathCorrector = lngPathCorrector;